export default {
  id: 108,
  title: 'Target #108 - Clow Card',
  url: 'https://cssbattle.dev/play/108',
  colors: ['#000000', '#E96A23', '#EBAE11'],
  solution:
    '<a a><a b><a c><a d><a e><style>[b],body{background:#000}a{position:fixed}[a]{top:75;left:50;width:300;height:150;background:linear-gradient(-75deg,#e96a23 36.3%,#ebae11 36.3% 43.9%,#e96a23 43.9% 48.1%,#ebae11 48.1% 63.4%,#e96a23 63.4%)}[b]{top:90;left:80;width:240;height:90;border-radius:12px;box-shadow:-15px 15px,15px 15px,0 30px}[c]{top:125;left:175;width:50;height:50;background:#ebae11;border-radius:9in}[d]{top:115;left:135;width:120;height:60;border:5px solid #ebae11;border-radius:100%}[e]{top:105;left:95;width:200;height:80;border:5px solid #ebae11;border-radius:100%}</style>',
}
